/* tslint:disable */
/* eslint-disable */
export enum EAccessTypes {
  Admin = 'ADMIN',
  Insurer = 'INSURER',
  Hospital = 'HOSPITAL',
  HomeKioskLight = 'HOME_KIOSK_LIGHT',
  HomeKiosk = 'HOME_KIOSK',
  Ticketing = 'TICKETING'
}
